import React from 'react';
import { Box } from '@mui/material';
import PDISection from '../collaborator/PDISection';

const PDIList: React.FC = () => (
    <Box p={3}>
        <PDISection />
    </Box>
);

export default PDIList;
